import { ActionTree } from 'vuex';
import { IDealroomViewState } from '@/dealroom-view/store/dealroom-view.store';
import {
  mutationSetDocument,
  mutationSetLoading,
  mutationSetLoaded,
  mutationSetPageWidth,
  mutationSetFields,
  mutationSetDocumentPages,
} from '@/dealroom-view/store/dealroom-view.mutations';
import { DocumentService } from '@/api/documents/services/document.service';
import { RootState } from '@/store/store';
import { IDocument } from '@/types/Document';
import { IField } from '@/fields/types/field';
import service from '@/fields/services/field.service';
import { IDocumentPage } from '@/types/document-page';

export const actionLoadDocument = 'loadDocument';
export const actionLoadDocumentSuccess = 'loadDocumentSuccess';
export const actionLoadDocumentFailed = 'loadDocumentFailed';

export const actionLoadFields = 'loadFields';
export const actionLoadFieldsSuccess = 'loadFieldsSuccess';
export const actionLoadFieldsFailed = 'loadFieldsFailed';

export const actionSetPageWidth = 'setPageWidth';

export const actionloadPageThumbUrl = 'loadPageThumbUrl';

export const actions: ActionTree<IDealroomViewState, RootState> = {
  async [actionLoadDocument]({ commit, dispatch }, documentId: string) {
    commit(mutationSetLoading, true);
    try {
      const document: IDocument = await DocumentService.loadDocument(documentId);
      dispatch(actionLoadDocumentSuccess, document);
    } catch (err) {
      this.dispatch(actionLoadDocumentFailed, err);
    }
  },
  async [actionLoadDocumentSuccess]({ dispatch, commit }, document: IDocument) {
    commit(mutationSetDocument, document);
    commit(mutationSetLoading, false);
    commit(mutationSetLoaded, true);
    dispatch(actionLoadFields, document.id);
  },
  async [actionLoadDocumentFailed]({ commit }) {
    commit(mutationSetLoading, false);
    commit(mutationSetLoaded, false);
  },
  async [actionSetPageWidth]({ commit }, pageWidth: number) {
    commit(mutationSetPageWidth, pageWidth);
  },
  async [actionLoadFields]({ dispatch }, documentId: string) {
    try {
      const fields: IField[] = await service.loadFields(documentId);
      dispatch(actionLoadFieldsSuccess, fields);
    } catch (error) {
      dispatch(actionLoadFieldsFailed, error);
    }
  },
  async [actionLoadFieldsSuccess]({ commit }, fields: IField[]) {
    commit(mutationSetFields, fields);
  },
  async [actionloadPageThumbUrl]({ commit, state }, pageId: string) {
    const { thumbUrl }: Partial<IDocumentPage> = await DocumentService.loadPageThumbUrl(
      pageId,
      state.document.id
    );
    const pages: IDocumentPage[] = state.document.pages.map((page: IDocumentPage) =>
      page.id === pageId
        ? {
            ...page,
            thumbUrl,
          }
        : page
    );
    commit(mutationSetDocumentPages, pages);
  },
  async [actionLoadFieldsFailed]() {},
};
